export default __webpack_public_path__ + "static/media/watermeloncooler-wide@2x.736495ef.jpg";